import React, {useState} from 'react';
import {AuthLayout} from "../../../core/layout/AuthLayout";
import BtnPrimary from "../../../shared/ui/button/primary/BtnPrimary";
import Table from "../../../shared/ui/table/table/Table";
import {TableData, TemplateTable} from "../../../shared/ui/table/models/TableProps";
import BtnDefault from "../../../shared/ui/button/default/BtnDefault";
import colorUtils from "../../../shared/colorUtils";
import {useSelector} from "react-redux";
import {selectPharmacies} from "../../../core/reducer/auth/authSlice";
import {padNumber} from "../../../shared/utils/dateUtils";
import IconButton from "../../../shared/ui/icon/IconBtn";
import FormAddCompany from "./components/FormAddCompany";
import ModalDeleteCompanyConfirm from "./components/ModalDeleteCompanyConfirm";
import http from "../../../shared/utils/http";
import {setEmployees} from "../../../core/reducer/pharmacySlice";


export function Companies() {
    const pharmacies = useSelector(selectPharmacies);
    const [addCompany, setAddCompany] = useState<any | undefined>();
    const [deleteCompanyModal, setDeleteCompanyModal] = useState<any | undefined>();
    const [stepDelete, setStepDelete] = useState(0)
    const [employees, setEmployees] = useState<any[]>()

    const deleteCompany = (data: any) => {
        setStepDelete(0)
        setDeleteCompanyModal(data)
    }
    const deletePharmacyCall = () => {
        http.delete(`pharmacies/${deleteCompanyModal?.idDocument}`).then(r => {
            setDeleteCompanyModal(undefined)
        })
    }

    const tableStructureCompanies: TableData[] = [
        {
            name: "name",
            label: "Azienda",
        },
        {
            name: "shiftDuration",
            label: "Durata turno",
        },
        {
            name: "openingHours",
            label: "Orari",
        },
        {
            name: "afternoonLimit",
            label: "Limite pomeridiano",
        },
        {
            name: "defaultColumn",
            label: "Gestione ore",
        },
        {
            name: "default",
            label: "Default",
        },

        {
            name: "action",
            label: "",
        },
    ];
    const templates: TemplateTable = {
        shiftDuration: (value: any, row: any) => (
            <div>{padNumber(value?.hours)}:{padNumber(value?.minutes)}</div>
        ),
        afternoonLimit: (value: any, row: any) => (
            <div>{padNumber(value?.hours)}:{padNumber(value?.minutes)}</div>
        ),
        openingHours: (value: any, row: any) => (
            <div className={'d-flex flex-wrap gap-2'} style={{maxWidth: '200px'}}>
                {value?.map((ele: any, i: number) =>
                    <div className={'d-flex'}>
                        <div>{padNumber(ele?.start?.hours)}:{padNumber(ele?.start?.minutes)}</div>
                        -
                        <div>{padNumber(ele?.end?.hours)}:{padNumber(ele?.end?.minutes)}</div>
                        {i < value.length - 1 && i % 2 === 0 && <div className="ps-2">|</div>}
                    </div>
                )}
            </div>
        ),
        defaultColumn:
            (value: any, row: any) => (
                <div>{row?.timeBank ? 'Banca Ore' : 'Straordinario'}</div>
            ),
        default:
            (value: any, row: any) => (
                <div>{value?.toString()}</div>
            ),
        action:
            (value: any, row: any) => (
                <div className={'d-flex justify-content-end gap-2'}>
                    <BtnDefault icon={'./assets/icons/edit.svg'} variant={'outline-primary'}
                                tintColor={colorUtils.theme.primary} onClick={() => setAddCompany(row)}/>
                    <BtnDefault icon={'./assets/icons/trash.svg'} variant={'outline-danger'}
                                tintColor={colorUtils.theme.red} onClick={() => deleteCompany(row)}/>
                </div>
            )
    }


    const confirmDelete = (state: 'next' | 'delete') => {
        state === 'delete' && deletePharmacyCall()
        state === 'next' && stepDelete === 0 && setStepDelete(stepDelete + 1)
        state === 'next' && stepDelete === 1 && deletePharmacyCall()
    }


    const closeDeleteModal = () => {
        setStepDelete(0)
        setDeleteCompanyModal(undefined)
    }

    const msgDelete: any = {
        0: `Confermando la cancellazione dell'azienda ${deleteCompanyModal?.name} perderai tutti i dati della stessa che non potrai più recuperare. Confermi?`,
        1: `Cancellando l'azienda ${deleteCompanyModal?.name} perderai tutte le ore impostate dei dipendenti e non potrai più recuperarle. Confermi?`,
    };
    return (
        <AuthLayout>
            <div className="row">
                <div className="col pt-3">
                    <div className={'d-flex justify-content-between align-items-center'}>
                        <h3>Lista Aziende</h3>
                        <BtnPrimary icon={'./assets/icons/plus-c.svg'} onClick={() => setAddCompany({})}>Aggiungi
                            azienda</BtnPrimary>
                    </div>
                    <div className="col list-container">
                        <Table columns={tableStructureCompanies} data={pharmacies}
                               templates={templates} rowIndexActive={['0']}/>
                    </div>
                </div>
                {addCompany && <div className="col py-3 shadow">
                    <div>
                        <div className={'d-flex justify-content-between align-items-center'}>
                            <h3>{addCompany?.idDocument ? 'Modifica' : 'Nuova'} azienda</h3>
                            <IconButton icon={'./assets/icons/close.svg'} size={'18px'}
                                        clickHandler={() => setAddCompany(undefined)}></IconButton>
                        </div>
                        <FormAddCompany closeFormHandler={() => setAddCompany(undefined)} dataEdit={addCompany}/>
                    </div>
                </div>}
                {deleteCompanyModal &&
                    <ModalDeleteCompanyConfirm data={deleteCompanyModal} confirmHandler={confirmDelete}
                                               msg={msgDelete[stepDelete]} step={stepDelete}
                                               closeHandler={closeDeleteModal} employees={employees}
                                               setEmployees={setEmployees}/>}
            </div>
        </AuthLayout>
    );
}


